// extracted by mini-css-extract-plugin
module.exports = {"root":"mobile-contents-module__root___k0xSP","accordeon":"mobile-contents-module__accordeon___kIP0x"};